import React from 'react';
import classNames from 'classnames';

function PersonalTrustpassInformationFormSubmitButton({
  information,
  submitting,
  onSave,
  hide_save,
}) {
  function buttonClassnames() {
    return classNames('ds-btn', '--medium', '--full', {_loading: submitting});
  }

  function isDisabled() {
    const disabled = !(
      information.first_name &&
      information.last_name &&
      information.birth_date &&
      information.phone_number &&
      information.email_address &&
      information.gender &&
      information.civil_status &&
      information.home_address
    );
    return disabled;
  }

  function renderSaveButton() {
    if (hide_save) return <div />;

    return (
      <button
        data-test="submit-button"
        className={buttonClassnames()}
        disabled={isDisabled()}
        onClick={onSave}>
        Submit your Personal Information
      </button>
    );
  }

  return renderSaveButton();
}

export default PersonalTrustpassInformationFormSubmitButton;



// WEBPACK FOOTER //
// ./src/features/trustpass/components/personal/InformationFormSubmitButton.js